import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ProblemSection() {
  const ref = useScrollReveal();
  return <section ref={ref} className="w-full section-padding" style={{
    backgroundColor: '#f0ebe2'
  }} aria-label="The problem" data-id="element-231">
      <div className="max-w-3xl mx-auto" data-id="element-232">
        {/* Label */}
        <div className="scroll-reveal text-center mb-10" data-id="element-233">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full" style={{
          color: '#c9a96e',
          backgroundColor: 'rgba(201,169,110,0.12)',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-234">
            The Real Problem
          </span>
        </div>

        {/* Heading */}
        <div className="scroll-reveal scroll-reveal-delay-1 text-center mb-8" data-id="element-235">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight" style={{
          fontFamily: "'Playfair Display', serif",
          color: '#1a2744'
        }} data-id="element-236">
            By 18 Months, Infant Sleep Advice{' '}
            <span className="italic" data-id="element-237">Stops Working.</span>
          </h2>
        </div>

        <div className="scroll-reveal scroll-reveal-delay-2 gold-divider mb-10" data-id="element-238" />

        {/* Body */}
        <div className="scroll-reveal scroll-reveal-delay-3 space-y-6" data-id="element-239">
          <p className="text-base md:text-lg leading-relaxed text-center" style={{
          color: '#4a4540',
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-240">
            You've tried the weighted blankets, the sound machines, and the
            "gentle" methods that promised results but delivered nothing but 5
            AM wake-up calls.
          </p>

          {/* The Jackpot box */}
          <div className="rounded-2xl p-6 md:p-8 mt-8" style={{
          backgroundColor: '#1a2744',
          border: '1px solid rgba(201,169,110,0.2)'
        }} data-id="element-241">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-242">
              Your Toddler Has Learned to Hunt for "The Jackpot."
            </h3>
            <p className="text-base leading-relaxed mb-4" style={{
            color: '#d4cfc8',
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-243">
              Every time you let them into your bed, or stay for "one more
              book," or offer a 3 AM snack, you are accidentally rewarding them
              for staying awake.
            </p>
            <p className="text-base leading-relaxed font-medium" style={{
            color: '#c9a96e',
            fontFamily: "'Inter', sans-serif"
          }} data-id="element-244">
              You are stuck in a cycle of intermittent reinforcement that is
              physically draining you — and straining your marriage.
            </p>
          </div>
        </div>
      </div>
    </section>;
}